import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import { API_BASE_URL } from "../constants/api";

const DataInfoPage = () => {
  const [mobileNo, setMobileNo] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const fetchDataInfo = async () => {
    setError("");
    const trimmedMobile = mobileNo.trim();
    if (!trimmedMobile) { setError("Please enter a mobile number."); return; }
    setLoading(true);
    try {
      const response = await fetch(
        `${API_BASE_URL}/sim/device?mobileNo=${encodeURIComponent(trimmedMobile)}`
      );
      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || "API request failed");
      }
      const result = await response.json();
      navigate("/data-info-result", { state: result.data ?? result });
    } catch (err) {
      console.error("API error:", err);
      setError(err.message || "Failed to fetch data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout title="Device Info">
      <div className="max-w-lg">
        <p className="mb-6" style={{ color: "#888888" }}>Enter a mobile number to retrieve device details.</p>

        <div className="rounded-2xl p-8" style={{ backgroundColor: "#1c1c1c", border: "1px solid #2a2a2a" }}>
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1" style={{ color: "#cccccc" }}>Mobile Number</label>
              <input
                type="text"
                placeholder="e.g. 9876543210"
                value={mobileNo}
                onChange={(e) => { setMobileNo(e.target.value); setError(""); }}
                onKeyDown={(e) => e.key === "Enter" && fetchDataInfo()}
                className="w-full px-4 py-2.5 rounded-xl text-sm placeholder-gray-600 focus:outline-none focus:ring-2 focus:ring-yellow-400 transition-colors"
                style={{ backgroundColor: "#111111", border: "1px solid #2a2a2a", color: "#ffffff" }}
              />
            </div>

            {error && <p className="text-sm" style={{ color: "#ef4444" }}>{error}</p>}

            <button
              onClick={fetchDataInfo}
              disabled={loading}
              className="w-full py-2.5 text-sm font-semibold rounded-xl transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
              style={{ backgroundColor: "#ffc20e", color: "#000000" }}
              onMouseEnter={(e) => { if (!loading) e.currentTarget.style.backgroundColor = "#e6ae00"; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "#ffc20e"; }}
            >
              {loading ? "Fetching..." : "Submit"}
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default DataInfoPage;
